import React from 'react';
import InfoPage, { Section } from '../../components/InfoPage';

const Privacy = () => (
  <InfoPage title="Privacy policy" lastUpdated="March 1, 2026">
    <p>
      This Privacy Policy describes how K-Root (“we”, “our”, or “us”) collects, uses, and shares personal information when you visit our site or place an order.
      By using our site you agree to the practices described below.
    </p>

    <Section heading="What we collect">
      <p>
        — Information you give us at checkout: name, shipping address, email, and phone number.<br />
        — Order details: products purchased, fulfillment status, and tracking number.<br />
        — Browser data: IP, device type, pages visited, and referral source.<br />
        — Cookies for cart, login, and basic analytics.
      </p>
    </Section>

    <Section heading="How we use it">
      <p>
        To process orders, communicate shipment updates, send (optional) marketing, prevent fraud, and improve the site experience.
        We do not sell your personal information.
      </p>
    </Section>

    <Section heading="Who we share it with">
      <p>
        Service providers strictly required to run the business: payment processors, shipping carriers, customer support tools,
        and analytics. Each provider is bound by their own privacy obligations.
      </p>
    </Section>

    <Section heading="Your rights">
      <p>
        You can request a copy of your data, ask us to correct or delete it, or opt out of marketing at any time by contacting our team.
        We respond within 30 days.
      </p>
    </Section>

    <Section heading="Contact">
      <p>Questions about this policy? Email <span className="underline">privacy@k-root.example</span>.</p>
    </Section>
  </InfoPage>
);

export default Privacy;
